import { Progress } from "../../components/ui/progress";
import { RecordingData } from "capacitor-voice-recorder";
import { useEffect, useState } from "react";
import { Fire } from "../../services/FireClient";
import { AudioPlayer } from "./AudioPlayer";
import { UIMessage } from "./UIMessage";
import { Play, Pause } from "lucide-react";

export type MessageItemState = 'new' | 'playing' | 'paused' | 'old';
const intervalTime = 200;

export interface IPlayMessageButton {
  m: UIMessage;
}

export const PlayMessageButton: React.FC<IPlayMessageButton> = ({ m }) => {
  const durationMS = m.msg.recording?.value.msDuration ?? 0;

  const [status] = useState({ currentMS: 0, active: false });
  const [playProgressRatio, setPlayProgressRatio] = useState(0);
  const [timeText, setTimeText] = useState("");

  useEffect(() => {
    if (m.msg.recording?.value) {
      const durationSec = Math.round(m.msg.recording?.value.msDuration / 1000 + 0.5);
      let time = new Date(durationSec * 1000);
      let timeStr = time.toTimeString().split(' ')[0];
      let timeValue = timeStr.slice(3, 8);
      setTimeText(timeValue)
    }
  }, [])


  if (m.msg.recording?.value) {
    return <div className="flex items-center gap-2 p-1 border rounded-full bg-background shadow-sm pr-3 h-8 w-fit max-w-[200px]">
      {status.active && <span onClick={() => stopVoice()} className="flex items-center gap-2 cursor-pointer w-full">
        <Pause className="w-5 h-5 fill-black text-foreground" />
        <Progress value={playProgressRatio} className="flex-1 h-1 w-16" />
        <small className="text-xs font-mono whitespace-nowrap">{timeText}</small>
      </span>
      }

      {!status.active && <span onClick={() => playVoice()} className="flex items-center gap-2 cursor-pointer w-full">
        {m.isNew() && <Play className="w-5 h-5 fill-black text-foreground" />}
        {!m.isNew() && <Play className="w-5 h-5 fill-gray-400 text-muted-foreground" />}
        <small className="text-xs font-mono whitespace-nowrap text-muted-foreground">{timeText}</small>
      </span>}
    </div>
  }
  else
    return <></>

  async function playVoice() {
    console.log('play voice');
    status.currentMS = 0;
    status.active = true;

    setPlayProgressRatio(0.1); // 0.1% -> practically 0 visual but non-zero? Original was 0.001 (0.1%).
    let interval = setInterval(() => {
      status.currentMS += intervalTime;
      // Original: status.currentMS / durationMS + 0.05
      // New: (status.currentMS / durationMS + 0.05) * 100
      let ratio = (status.currentMS / durationMS + 0.05);
      if (ratio > 1) ratio = 1;
      setPlayProgressRatio(ratio * 100);

      if (status.currentMS >= durationMS || !status.active) {
        clearInterval(interval);
        status.active = false;
        setPlayProgressRatio(0);
      }
    }, intervalTime)
    Fire.clearNotificationByMessageId(m.msg.id);
    await AudioPlayerForMessage.playMessage(m.msg.recording, () => {
      status.active = false
      setPlayProgressRatio(0);
    });
  }

  function stopVoice() {
    status.active = false;
    AudioPlayerForMessage.stop();
  }
}


class AudioPlayerForMessage {
  private static player = new AudioPlayer(new Audio());
  private static cancelLast?: () => void = () => { };

  static async playMessage(data: RecordingData | undefined, onCancel: () => void) {
    this.cancelLast && this.cancelLast();
    this.cancelLast = onCancel;
    await this.player.playData(data);
    this.cancelLast = undefined;
  }

  static stop() {
    this.player.stop();
    this.cancelLast = undefined;
  }
}